import { Outlet } from "react-router-dom";

type Props = {};

export default function RecorderPage(props: Props): JSX.Element {
  const outletContext = {};

  return <Outlet context={outletContext} />;
}
